/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import {
  Collapse,
  Form,
  FormInstance,
  Modal,
  Select,
  Tooltip,
  notification,
} from "antd";
import { Link, useHistory } from "react-router-dom";
// @ts-ignore
// import { useMediaQuery } from "react-responsive";
import { HiOutlineUser, HiOutlineMail, HiOutlinePhone } from "react-icons/hi";
import { BiErrorCircle, BiUnite } from "react-icons/bi";
import { GoLocation } from "react-icons/go";
// import { RiDownloadLine } from "react-icons/ri";
import {
  MdOutlineKeyboardBackspace,
  MdOutlineNavigateNext,
} from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { CalendarOutlined, DownloadOutlined } from "@ant-design/icons";
import { BiTrash } from "react-icons/bi";

import OrderDetailItem from "./OrderDetailItem";
import Dropdown from "./Dropdown";
import Loader from "./Loader";
import {
  getOrderDetail,
  userSelector,
  getStatusList,
  searchProductListing,
  addOrderItem,
  updateOrderItem,
  addOrderAttachment,
  deleteOrderAttachment,
  orderApprove,
  orderHoldStatus,
  cancelOrder,
  getEnumTypeList,
  updateShipmentShippingMethod,
  AwsUserPreference,
  splitOrder,
  importData,
  getTemplatesList,
  getImportListing,
  updateOrderShippingAddress,
  getGeoCountries,
  getGeoStates,
} from "../redux/authSlice";
import Table from "./Table";
import Button from "./Button";
import { debounceFn } from "../helper/function";
import Input from "./Input";
import UploadFile from "./UploadFile";
import { BiEdit } from "react-icons/bi";
import UploadDocument from "./UploadDocument";
import moment from "moment";
import axios from "axios";
import ProgressBar from "@ramonak/react-progress-bar";
import { AiOutlineFilter } from "react-icons/ai";
import ImportListing from "./ImportListing";
import CountDown from "./Countdown";

const OrderDetail = ({
  id,
  handleIdValidity,
}: {
  id: string;
  handleIdValidity: Function;
}) => {
  const history = useHistory();
  const [mapForm] = Form.useForm();
  const [addForm] = Form.useForm();
  const [updateForm] = Form.useForm();
  const [importForm] = Form.useForm();
  const [uploadDocumentForm] = Form.useForm();
  const [shippingMethodForm] = Form.useForm();
  const [editAddressForm] = Form.useForm();
  // const isMobileDevice = useMediaQuery({
  //   query: "(max-device-width: 450px)",
  // });
  const dispatch = useDispatch();
  const { Panel } = Collapse;
  const collapseRef: any = useRef(null);
  const { confirm } = Modal;
  const { activeOrgToggled, activeOrgStores, countriesList, statesList } =
    useSelector(userSelector);
  const [orderDetailData, setOrderDetailData] = useState<any>([]);
  const [childOrderdata, setChildOrderdata] = useState<any>([]);
  const [currStatus, setCurrStatus] = useState<any>("");
  const [orderStatus, setOrderStatus] = useState<any>([]);
  const [returnStatus, setReturnStatus] = useState<any>([]);
  const [shipmentStatus, setShipmentStatus] = useState<any>([]);
  const [customerContact, setCustomerContact] = useState<any>([]);
  const [, setCurrentDate] = useState("");
  const [shipping, setShipping] = useState<any>("");
  const [grandTotal, setGrandTotal] = useState<any>("");
  const [discount, setDiscount] = useState<any>(0);
  const [salesTax, setSalesTax] = useState<any>([]);
  const [subTotal, setSubTotal] = useState<any>([]);
  const [paymentList, setPaymentList] = useState<any>([]);
  const [shipmentDetails, setShipmentDetails] = useState<any>([]);
  // const [shipmentGridDetail, setShipmentGridDetail] = useState<any>([]);
  const [shipmentGridDetail, setShipmentGridDetail] = useState<any>([]);
  const [shipmentItemDetail, setShipmentItemDetail] = useState<any>([]);
  const [customerShippingInfo, setCustomerShippingInfo] = useState<any>({});
  const [orderItems, setOrderItems] = useState<any>([]);
  const [totalQty, setTotalQty] = useState(0);
  // const [isExistingCustomer, setIsExistingCustomer] = useState<any>(false)
  const [, setStatusOnSave] = useState<any>("");
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDocumentModalOpen, setIsDocumentModalOpen] = useState(false);
  const [csvFile, setCsvFile] = useState<any>(null);
  const [file, setFile] = useState<any>(null);
  const [showUploadList, setShowUploadList] = useState(false);
  const [isForceLoading, setIsForceLoading] = useState(false);
  const [isFirstTimeRendering, setIsFirstTimeRendering] = useState(true);
  const [selectedProduct, setSelectedProduct] = useState<any>(null);
  const [productList, setProductList] = useState<any>([]);
  const [searchableString, setSearchableString] = useState("");
  const [maxPageIndex, setMaxPageIndex] = useState<any>("");
  const [currIndex, setCurrIndex] = useState<any>(1);
  const [hasMoreProds, setHasMoreProds] = useState(true);
  const [isAddItemModalOpen, setIsAddItemModalOpen] = useState(false);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [returnEnumType, setReturnEnumType] = useState<any>([]);
  const [itemPropertyEnumType, setItemPropertyEnumType] = useState<any>([]);
  const [isShippingMethodModalOpen, setIsShippingMethodModalOpen] =
    useState(false);
  const [isEditAddressModalOpen, setIsEditAddressModalOpen] = useState(false);
  const [shippingMethods, setShippingMethods] = useState([]);
  const [amazonAws, setAmazonAws] = useState("");
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [csvFileForOrder, setCsvFileForOrder] = useState<any>(null);
  const [importStatus, setImportStatus] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [uploadCompletionRate, setUploadCompletionRate] = useState(5);
  const [importId, setImportId] = useState("");
  const [templateList, setTemplateList] = useState([]);
  const [shouldRerender, setShouldRerender] = useState(false);
  const [palletShipments, setPalletShipments] = useState<any>({});
  
  // Freight Packing List button state by shipment
  const [packingListShipments, setPackingListShipments] = useState<Record<string, { show?:boolean, enabled?:boolean, reason?:string }>>({});
  // Bill of Lading button state by shipment
  const [bolShipments, setBolShipments] = useState<Record<string, { show?:boolean, enabled?:boolean, reason?:string }>>({});

  // Label download buttons loading state
  const [packingListDownloading, setPackingListDownloading] = useState(false);
  const [packingSlipDownloading, setPackingSlipDownloading] = useState(false);
  const [freightPackingListDownloading, setFreightPackingListDownloading] = useState(false);
  const [bolDownloading, setBolDownloading] = useState(false);

  // Per-org gate for the Box Content XLSX (Amazon report) button
  const [allowBoxContentXLSX] = useState(
    () => localStorage.getItem("allowBoxContentXLSX") === "true"
  );
  // const [selectedFromDate, setSelectedFromDate] = useState(
  //       fromDate
  //         ? fromDate
  //         : localStorage.getItem("importListingFromDate")
  //         ? localStorage.getItem("importListingFromDate")
  //         : ""
  //     );
  //     const [selectedThruDate, setSelectedThruDate] = useState(
  //       thruDate
  //         ? thruDate
  //         : localStorage.getItem("importListingThruDate")
  //         ? localStorage.getItem("importListingThruDate")
  //         : ""
  //     );  

  useEffect(() => {
    fetchData();
  }, [activeOrgToggled, id]); // eslint-disable-line
  useEffect(() => {
    setIsFirstTimeRendering(true);
  }, [id]);
  const fetchData = async () => {
    setIsLoading(true);
    await dispatch(
      getOrderDetail({
        setOrderDetailData,
        setChildOrderdata,
        setTotalQty,
        setCurrStatus,
        setStatusOnSave,
        setCustomerContact,
        setGrandTotal,
        setShipping,
        setDiscount,
        setSalesTax,
        setSubTotal,
        setPaymentList,
        id,
        setShipmentDetails,
        setShipmentGridDetail,
        setCustomerShippingInfo,
        setShipmentItemDetail,
        setOrderItems,
        setShippingMethods,
        setIsFirstTimeRendering,
        handleIdValidity,
      })
    );
    await dispatch(
      getStatusList({ setStatus: setOrderStatus, statusTypeId: "OrderHeader" })
    );
    await dispatch(
      getStatusList({ setStatus: setReturnStatus, statusTypeId: "Return" })
    );
    await dispatch(
      getStatusList({ setStatus: setShipmentStatus, statusTypeId: "Shipment" })
    );
    await dispatch(
      getEnumTypeList({
        setEnumType: setReturnEnumType,
        enumTypeId: "ReturnReason",
      })
    );
    await dispatch(
      getEnumTypeList({
        setEnumType: setItemPropertyEnumType,
        enumTypeId: "ItemProperties",
      })
    );
    await dispatch(AwsUserPreference({ setAmazonAws }));
    // await dispatch(
    //   getCustomersList({ setPageCount, setMaxPageIndex, pageIndex: 0 })
    // );
    // await dispatch(getGeoCountries());
    setIsLoading(false);
    // await dispatch(getStatusListForOrder(setProductStatusData))
    const date = new Date(Date.now() - 2 * 60 * 60 * 1000);
    let formatAMPM: any = date.getHours() / 12;
    if (formatAMPM >= 1) {
      formatAMPM = "PM";
    } else {
      formatAMPM = "AM";
    }
    let minutes: any = date.getMinutes();
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    let currDate = date.toLocaleString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
    currDate += `, ${date.getHours() % 12 === 0 ? 12 : date.getHours() % 12
      }:${minutes} ${formatAMPM}`;
    setCurrentDate(currDate);
  };

  useEffect(() => {
    if (!shipmentGridDetail?.length) return;
    const checkPalletShipments = async () => {
      const baseUrl = process.env.REACT_APP_API_BASE_URL;
      const token = localStorage.getItem("moquiSessionToken") || "";
      const partyId = localStorage.getItem("organizationPartyId") || "";
      const finalShipmentStatuses = ["ShipPacked", "ShipDelivered", "ShipShipped"];
      const entries = await Promise.all(shipmentGridDetail.map(async (shipment: any) => {
        try {
          const response = await axios.get(`${baseUrl}/rest/s1/handheld/shipment/${shipment?.shipmentId}`, {
            params: { isOutgoing: true, partyId, includeContainers: true },
            headers: { moquiSessionToken: token },
          });
          const shipmentPackageSeqIds = response?.data?.shipmentPackageList?.map(
            (shipmentPackage: any) => String(shipmentPackage?.shipmentPackageSeqId)
          ) || [];
          const containerPackageSeqIds = new Set(
            (response?.data?.shipmentContainerList || [])
              .map((shipmentContainer: any) => shipmentContainer?.shipmentPackageSeqId)
              .filter(Boolean)
              .map(String)
          );
          const allPackagesHaveContainers =
            shipmentPackageSeqIds.length > 0 &&
            shipmentPackageSeqIds.every((shipmentPackageSeqId: string) =>
              containerPackageSeqIds.has(shipmentPackageSeqId)
            );
          const hasFinalShipmentStatus = finalShipmentStatuses.includes(response?.data?.statusId);
          const isFreight = !!response?.data?.allowsPallet;
          const betaPacked = allPackagesHaveContainers && hasFinalShipmentStatus;
          return [
            shipment?.shipmentId,
            {
              pallet: isFreight && betaPacked,
              packingList: {
                show: isFreight,
                enabled: isFreight && betaPacked,
                reason: !hasFinalShipmentStatus
                  ? "Shipment is not packed yet"
                  : "Unsupported for this shipment",
              },
              bol: {
                show: isFreight,
                enabled: isFreight && betaPacked,
                reason: !hasFinalShipmentStatus
                  ? "Shipment is not packed yet"
                  : "Unsupported for this shipment",
              },
            },
          ];
        } catch (error) {
          console.log(error);
          return [shipment?.shipmentId, { pallet: false, packingList: { show: false, enabled: false, reason: "" }, bol: { show: false, enabled: false, reason: "" } }];
        }
      }));
      setPalletShipments(Object.fromEntries(entries.map(([shipmentId, value]: any) => [shipmentId, value.pallet])));
      setPackingListShipments(Object.fromEntries(entries.map(([shipmentId, value]: any) => [shipmentId, value.packingList])));
      setBolShipments(Object.fromEntries(entries.map(([shipmentId, value]: any) => [shipmentId, value.bol])));
    };
    checkPalletShipments();
  }, [shipmentGridDetail]);

  const emailAddress =
    orderDetailData &&
    orderDetailData.order &&
    orderDetailData.order.parts[0].customerEmail;

  const currentOrderPart = orderDetailData?.order?.parts?.[0];
  // editableShippingAddress/editableShippingTelecomNumber/editableShippingAddressStateGeo
  // come from the backend (fp.OrderServices.get#OrderDetails) already resolved to whichever
  // address is currently authoritative - the order's own postalAddress if there's no
  // shipment that hasn't shipped yet, or that shipment's own destination address otherwise.
  // Falling back to the order's own postalAddress/telecomNumber/postalAddressStateGeo keeps
  // this safe against an older backend that doesn't return the new fields yet.
  const displayPostalAddress =
    currentOrderPart?.editableShippingAddress ?? currentOrderPart?.postalAddress;
  const displayTelecomNumber =
    currentOrderPart?.editableShippingTelecomNumber ?? currentOrderPart?.telecomNumber;
  const displayStateGeo =
    currentOrderPart?.editableShippingAddressStateGeo ??
    currentOrderPart?.postalAddressStateGeo;
  // Email string for the currently-editable address (order's own or the eligible shipment's),
  // resolved by the backend. Falls back to the order-level email for older backends.
  const displayEmail =
    currentOrderPart?.editableShippingEmail ??
    orderDetailData?.order?.postalContactEmailAddress;
  // Same shipment statuses the admin OMS Shipment Detail screen allows
  // "Update Address" for (mantle.shipment.ShipmentInfoServices.get#ShipmentDisplayInfo
  // allowUpdate, plus its screen-level "|| statusId == 'ShipPacked'" override).
  const SHIPMENT_ADDRESS_EDITABLE_STATUSES = [
    "ShipInput",
    "ShipScheduled",
    "ShipPicked",
    "ShipPacked",
  ];
  const hasAddressEditableShipment = shipmentGridDetail?.some((shipment: any) =>
    SHIPMENT_ADDRESS_EDITABLE_STATUSES.includes(shipment?.statusId)
  );
  // partEditable comes straight from the backend's order status check
  // (mantle.order.OrderInfoServices.get#OrderDisplayInfo) - same rule the
  // admin OMS screen uses to gate its own "Update Address" action. Once the
  // order itself is past that (e.g. Approved), still allow editing as long as
  // a shipment exists and hasn't progressed past Packed - same as the admin
  // Shipment Detail screen would allow for that shipment.
  const isShippingAddressEditable =
    currentOrderPart?.partEditable === true || hasAddressEditableShipment;

  const openEditAddressModal = () => {
    if (!countriesList?.length) {
      dispatch(getGeoCountries());
    }
    const postalAddress = displayPostalAddress || {};
    const telecomNumber = displayTelecomNumber || {};
    const countryGeoId = postalAddress?.countryGeoId;
    editAddressForm.setFieldsValue({
      name: postalAddress?.toName,
      attnName: postalAddress?.attnName,
      address1: postalAddress?.address1,
      unitNumber: postalAddress?.unitNumber,
      address2: postalAddress?.address2,
      city: postalAddress?.city,
      postalCode: postalAddress?.postalCode,
      postalCodeExt: postalAddress?.postalCodeExt,
      country: countryGeoId,
      state: postalAddress?.stateProvinceGeoId,
      countryCode: telecomNumber?.countryCode,
      areaCode: telecomNumber?.areaCode,
      contactNumber: telecomNumber?.contactNumber,
      telecomExtension: telecomNumber?.extension,
      email: displayEmail,
    });
    if (countryGeoId) {
      dispatch(getGeoStates(countryGeoId));
    }
    setIsEditAddressModalOpen(true);
  };

  const selectEditAddressCountry = (val: any) => {
    editAddressForm.setFieldsValue({ country: val, state: "" });
    dispatch(getGeoStates(val));
  };

  function dateConvert(date: any) {
    const data = new Date(date).toDateString().split(" ").slice(1).join(" ");
    return data;
  }
  function timeConvert(time: any) {
    const dis = new Date(time).toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
    return dis;
  }
  // const newData =
  //   orderDetailData.order && orderDetailData.order.orderHistoryAndNotes;
  const orderId =
    " " + orderDetailData &&
    orderDetailData.order &&
    orderDetailData.order.orderId;
  const placedDate =
    "Placed" +
    " " +
    dateConvert(
      orderDetailData &&
      orderDetailData.order &&
      orderDetailData.order.placedDate
    ) +
    " " +
    timeConvert(
      orderDetailData &&
      orderDetailData.order &&
      orderDetailData.order.placedDate
    );

  const getShippedDate = (index: any) => {
    const actualStartDate =
      orderDetailData &&
        orderDetailData?.order &&
        orderDetailData?.order?.shipmentRouteSegment &&
        orderDetailData?.order?.shipmentRouteSegment?.length > 0 &&
        orderDetailData?.order?.shipmentRouteSegment?.[index]?.actualStartDate
        ? orderDetailData?.order?.shipmentRouteSegment?.[index]?.actualStartDate
        : "";
    const shippedDate = actualStartDate
      ? "Shipped " +
      dateConvert(actualStartDate) +
      " " +
      timeConvert(actualStartDate)
      : "";
    return shippedDate;
  };
  // const emailAddress =
  //   orderDetailData &&
  //   orderDetailData.order &&
  //   orderDetailData.order.parts[0].customerEmail;
  // const downloadCsv = async () => {
  //   await dispatch(downloadCsvManifestFile({ orderId: id }));
  // };
  // const shipToHeader: any = (
  //   <h1 className="text-xl font-bold">Edit Ship To Address</h1>
  // );
  function showProductInfo(id: any) {
    const productInfo = orderItems?.find((item: any) => item?.productId === id);
    return productInfo
      ? {
        productName: productInfo.productName,
        sku: productInfo.sku,
        upc: productInfo.upc,
      }
      : null;
  }

  const columns = [
    ...(shipmentGridDetail &&
      shipmentGridDetail.length === 0 &&
      (!orderDetailData?.order?.salesChannelEnumId ||
        orderDetailData?.order?.salesChannelEnumId === "ScWeb" ||
        (orderDetailData?.order?.salesChannelEnumId &&
          orderDetailData?.order?.statusId === "OrderHold"))
      ? [
        {
          title: (
            <div className="flex items-center relative h-5 p-2 leading-3">
              <p className="mr-1"></p>
            </div>
          ),
          dataIndex: "update",
          render: (sku: string, data: any) => {
            return (
              <div className="flex flex-row items-center">
                <div className="flex flex-row">
                  <h1
                    className="ml-2"
                    onClick={() => {
                      const selectedItem: any = orderItems.find(
                        (item: any) =>
                          item.orderItemSeqId === data?.orderItemSeqId
                      );
                      if (selectedItem) {
                        updateForm?.setFieldsValue({
                          productName: selectedItem?.productName,
                          productId: selectedItem?.productId,
                          orderItemSeqId: selectedItem?.orderItemSeqId,
                          quantity: selectedItem?.quantity,
                          itemProperties: selectedItem?.itemProperties || null,
                          // unitAmount: selectedItem?.unitAmount,
                        });
                        setIsUpdateModalOpen(true);
                      }
                    }}
                  >
                    <BiEdit className="ml-1 sm:ml-2 text-lg font-semibol text-primary cursor-pointer" />
                  </h1>
                </div>
              </div>
            );
          },
        },
      ]
      : []),
    {
      title: (
        <div className="flex items-center relative h-5 p-2 leading-3">
          <p className="mr-1">SKU</p>
        </div>
      ),
      dataIndex: "sku",
      render: (sku: string, data: any) => (
        <Link
          to={{
            pathname: `/product/${data?.productId}`,
            state: { productId: data?.productId },
          }}
        >
          <h1 className="cursor-pointer text-primary underline">{sku}</h1>
        </Link>
      ),
    },
    {
      title: (
        <div className="flex items-center relative h-5 p-2 leading-3">
          <p className="mr-1">UPC</p>
        </div>
      ),
      dataIndex: "upc",
      render: (upc: string, data: any) => (
        <Link
          to={{
            pathname: `/product/${data?.productId}`,
            state: { productId: data?.productId },
          }}
        >
          <h1 className="cursor-pointer text-primary underline">{upc}</h1>
        </Link>
      ),
    },
    {
      title: (
        <div className="flex items-center relative h-5 p-2 leading-3">
          <p className="mr-1">Product Name</p>
        </div>
      ),
      dataIndex: "productName",
      render: (productName: string, data: any) => {
        const overAllocated =
          orderDetailData?.order?.overAllocatedOrderItems ?? [];

        const parentMatched = overAllocated.some((arr: any) =>
          arr.some(
            (subItem: any) =>
              subItem.productId === data.productId &&
              subItem.orderItemSeqId === data.orderItemSeqId
          )
        );

        return (
          <div>
            {parentMatched ? (
              <h1 className="px-2">{productName}</h1>
            ) : (
              <h2 className="px-2">{productName}</h2>
            )}
            {data?.componentProductList?.map((compData: any) => {
              const compMatched = overAllocated.some((arr: any) =>
                arr.some(
                  (subItem: any) =>
                    subItem.productId === compData.componentProductId &&
                    subItem.orderItemSeqId === compData.orderItemSeqId
                )
              );

              return compMatched ? (
                <Link
                  to={{ pathname: `/product/${compData?.componentProductId}` }}
                >
                  <h1 className="cursor-pointer text-red-500 underline px-2">
                    <strong>Component: </strong>
                    {compData.productName}
                  </h1>
                </Link>
              ) : (
                <Link
                  to={{ pathname: `/product/${compData?.componentProductId}` }}
                >
                  <h2 className="cursor-pointer text-primary underline px-2">
                    <strong>Component: </strong>
                    {compData.productName}
                  </h2>
                </Link>
              );
            })}
          </div>
        );
      },
    },
    // {
    //   title: (
    //     <div className="flex items-center relative h-5 p-2 leading-3">
    //       <p className="mr-1">Price</p>
    //     </div>
    //   ),
    //   dataIndex: "unitAmount",
    //   render: (unitAmount: number) => (
    //     <h1 className="px-2">$ {unitAmount?.toFixed(2)}</h1>
    //   ),
    // },
    {
      title: (
        <div className="flex items-center relative h-5 p-2 leading-3">
          <p className="mr-1">QTY</p>
        </div>
      ),
      dataIndex: "quantity",
      render: (quantity: number, data: any) => {
        const overAllocated =
          orderDetailData?.order?.overAllocatedOrderItems ?? [];
        const parentMatched = overAllocated.some((arr: any) =>
          arr.some(
            (subItem: any) =>
              subItem.productId === data.productId &&
              subItem.orderItemSeqId === data.orderItemSeqId
          )
        );
        return (
          <div>
            {parentMatched ? (
              <h1 className="px-2">{quantity}</h1>
            ) : (
              <h2 className="px-2">{quantity}</h2>
            )}
            {data?.componentProductList?.map((compData: any) => {
              const compMatched = overAllocated.some((arr: any) =>
                arr.some(
                  (subItem: any) =>
                    subItem.productId === compData.componentProductId &&
                    subItem.orderItemSeqId === compData.orderItemSeqId
                )
              );

              return compMatched ? (
                <h1 className="px-2">{compData.quantity}</h1>
              ) : (
                <h2 className="px-2">{compData.quantity}</h2>
              );
            })}
          </div>
        );
      },
    },
    {
      title: (
        <div className="flex items-center relative h-5 p-2 leading-3">
          <p className="mr-1">Cancelled QTY</p>
        </div>
      ),
      dataIndex: "quantityCancelled",
      render: (quantityCancelled: number, data: any) => {
        const overAllocated =
          orderDetailData?.order?.overAllocatedOrderItems ?? [];
        const parentMatched = overAllocated.some((arr: any) =>
          arr.some(
            (subItem: any) =>
              subItem.productId === data.productId &&
              subItem.orderItemSeqId === data.orderItemSeqId
          )
        );
        const parentCancelled = quantityCancelled ?? 0;
        return (
          <div>
            {parentMatched ? (
              <h1 className="px-2">{parentCancelled}</h1>
            ) : (
              <h2 className="px-2">{parentCancelled}</h2>
            )}
            {data?.componentProductList?.map((compData: any) => {
              const componentCancelled = compData?.quantityCancelled ?? 0;

              const compMatched = overAllocated.some((arr: any) =>
                arr.some(
                  (subItem: any) =>
                    subItem.productId === compData.componentProductId &&
                    subItem.orderItemSeqId === compData.orderItemSeqId
                )
              );

              return compMatched ? (
                <h1 className="px-2">{componentCancelled}</h1>
              ) : (
                <h2 className="px-2">{componentCancelled}</h2>
              );
            })}
          </div>
        );
      },
    },
    {
      title: (
        <div className="flex items-center relative h-5 p-2 leading-3">
          <p className="mr-1">Short QTY</p>
        </div>
      ),
      dataIndex: "productId",
      render: (productId: any, data: any) => {
        let product: any =
          orderDetailData?.order?.overAllocatedOrderItems?.find((item: any) =>
            item.some(
              (subItem: any) =>
                subItem?.productId === productId &&
                subItem?.orderItemSeqId === data?.orderItemSeqId
            )
          );
        let parentShortQty = 0;
        if (product) {
          parentShortQty = product
            .filter(
              (subItem: any) =>
                subItem?.productId === productId &&
                subItem?.orderItemSeqId === data?.orderItemSeqId
            )
            .reduce(
              (acc: number, subItem: any) =>
                acc + (subItem?.quantityNotAvailable ?? 0),
              0
            );
        }
        let componentProduct: any =
          data?.componentProductList &&
          orderDetailData?.order?.overAllocatedOrderItems?.find((item: any) =>
            item.some((subItem: any) =>
              data?.componentProductList?.find(
                (comp: any) =>
                  comp?.componentProductId === subItem?.productId &&
                  comp?.orderItemSeqId === subItem?.orderItemSeqId
              )
            )
          );
        return (
          <div>
            {product ? (
              <h1 className="px-2">{parentShortQty}</h1>
            ) : (
              <h2 className="px-2">0</h2>
            )}
            {data?.componentProductList.length > 0 &&
              data?.componentProductList?.map((compData: any) => {
                const matchedSubItems = componentProduct?.filter(
                  (item: any) =>
                    item.productId === compData.componentProductId &&
                    item.orderItemSeqId === compData.orderItemSeqId
                );

                if (matchedSubItems && matchedSubItems.length > 0) {
                  const sumShortQty = matchedSubItems.reduce(
                    (acc: number, item: any) =>
                      acc + (item.quantityNotAvailable ?? 0),
                    0
                  );
                  return <h1 className="px-2">{sumShortQty}</h1>;
                } else {
                  return <h2 className="px-2">0</h2>;
                }
              })}
          </div>
        );
      },
    },
    {
      title: (
        <div className="flex items-center relative h-5 p-2 leading-3">
          <p className="mr-1">Serialized?</p>
        </div>
      ),
      dataIndex: "serialized",
      render: (serialized: any) => {
        return serialized === "Y" && <h1 className="px-2">Serialized</h1>;
      },
    },
    {
      title: (
        <div className="flex items-center relative h-5 p-2 leading-3">
          <p className="mr-1">Serial No.</p>
        </div>
      ),
      dataIndex: "serialNumber",
      render: (serialNumber: any) => {
        return (
          serialNumber?.length > 0 &&
          serialNumber?.map((item: any) => {
            return <h1 className="px-2">{item}</h1>;
          })
        );
      },
    },
      {
      title: (
        <div className="flex items-center relative h-5 p-2 leading-3">
          <p className="mr-1">Unit Amount</p>
        </div>
      ),
      dataIndex: "unitAmount",
    },
  ];

  const orderAttachmentColumns = [
    {
      title: (
        <div className="flex items-center relative h-5 p-2 leading-3">
          <p className="mr-1"></p>
        </div>
      ),
      dataIndex: "orderContentId",
      render: (orderContentId: string, data: any) => {
        return (
          <div className="flex flex-row items-center">
            <div className="flex flex-row ">
              <h1
                className=""
                onClick={() => {
                  confirm({
                    title: "Are you sure?",
                    icon: "",
                    content: "Do you want to delete this attachment?",
                    okText: "Delete",

                    onOk: async () => {
                      setIsForceLoading(true);
                      await dispatch(
                        deleteOrderAttachment({ orderContentId, fetchData })
                      );
                      setIsForceLoading(false);
                    },
                    onCancel() {
                      // console.log("Cancel");
                    },
                  });
                }}
              >
                <BiTrash className="ml-1 sm:ml-2 text-lg font-semibold text-primary cursor-pointer" />
              </h1>
            </div>
          </div>
        );
      },
    },
    {
      title: (
        <div className="flex items-center relative h-5 p-2 leading-3">
          <p className="mr-1">Name</p>
        </div>
      ),
      dataIndex: "orderContentId",
      render: (orderContentId: string, data: any) => {
        let fileName = data?.contentLocation?.split("/");
        fileName = fileName[fileName?.length - 1];
        return (
          <h1
            className="cursor-pointer underline text-primary"
            onClick={() => {
              const uri = `${process.env.REACT_APP_API_BASE_URL}/apps/oms/Order/OrderDetail/downloadContent?orderContentId=${orderContentId}&orderId=${id}`;
              window.location.href = uri;
            }}
          >
            {fileName}
          </h1>
        );
      },
    },
    {
      title: (
        <div className="flex items-center relative h-5 p-2 leading-3">
          <p className="mr-1">Description</p>
        </div>
      ),
      dataIndex: "description",
      render: (description: string) => <h1 className="px-2">{description}</h1>,
    },
    {
      title: (
        <div className="flex items-center relative h-5 p-2 leading-3">
          <p className="mr-1">Added By</p>
        </div>
      ),
      dataIndex: "userName",
      render: (userName: string) => <h1 className="px-2">{userName}</h1>,
    },
    {
      title: (
        <div className="flex items-center relative h-5 p-2 leading-3">
          <p className="mr-1">Date Uploaded</p>
        </div>
      ),
      dataIndex: "contentDate",
      render: (contentDate: string) => (
        <h1 className="px-2">
          {contentDate ? moment(contentDate)?.format("YYYY-MM-DD ") : ""}
        </h1>
      ),
    },
  ];

  const ReturnInfo = [
    {
      title: (
        <div className="flex items-center relative h-5 p-2 leading-3">
          <p className="mr-1">Product Name</p>
        </div>
      ),
      dataIndex: "productId",
      render: (productId: any) => {
        return (
          <h1 className="px-2">{showProductInfo(productId)?.productName}</h1>
        );
      },
    },
    {
      title: (
        <div className="flex items-center relative h-5 p-2 leading-3">
          <p className="mr-1">SKU</p>
        </div>
      ),
      dataIndex: "productId",
      render: (productId: any) => {
        return (
          <Link
            to={{
              pathname: `/product/${productId}`,
              state: { productId: productId },
            }}
          >
            <h1 className="cursor-pointer text-primary underline px-2">
              {showProductInfo(productId)?.sku}
            </h1>
          </Link>
        );
      },
    },
    {
      title: (
        <div className="flex items-center relative h-5 p-2 leading-3">
          <p className="mr-1">UPC</p>
        </div>
      ),
      dataIndex: "productId",
      render: (productId: any) => {
        return (
          <Link
            to={{
              pathname: `/product/${productId}`,
              state: { productId: productId },
            }}
          >
            <h1 className="cursor-pointer text-primary underline px-2">
              {showProductInfo(productId)?.upc}
            </h1>
          </Link>
        );
      },
    },
    {
      title: (
        <div className="flex items-center relative h-5 p-2 leading-3">
          <p className="mr-1">Status</p>
        </div>
      ),
      dataIndex: "returnStatusId",
      render: (returnStatusId: any) => {
        return (
          <h1
            style={{
              backgroundColor: "#093479",
              outlineColor: "#707070",
              border: "1px solid #707070",
            }}
            className="px-1.5 py-0.5 text-center text-white tracking-wider border font-semibold rounded-md w-max"
          >
            {returnStatus
              ?.find((item: any) => item?.key === returnStatusId)
              ?.value?.toUpperCase()}
          </h1>
        );
      },
    },
    {
      title: (
        <div className="flex items-center relative h-5 p-2 leading-3">
          <p className="mr-1">Retuned Quantity</p>
        </div>
      ),
      dataIndex: "returnQuantity",
      render: (returnQuantity: any) => (
        <h1 className="px-2">{returnQuantity}</h1>
      ),
    },
    {
      title: (
        <div className="flex items-center relative h-5 p-2 leading-3">
          <p className="mr-1">Comment</p>
        </div>
      ),
      dataIndex: "comments",
      render: (comments: any) => <h1 className="px-2">{comments}</h1>,
    },
    {
      title: (
        <div className="flex items-center relative h-5 p-2 leading-3">
          <p className="mr-1">Reason</p>
        </div>
      ),
      dataIndex: "reason",
      render: (reason: any) => (
        <h1 className="px-2">
          {returnEnumType?.find((item: any) => item?.key === reason)?.value}
        </h1>
      ),
    },
    {
      title: (
        <div className="flex items-center relative h-5 p-2 leading-3">
          <p className="mr-1">Return Info (ReturnID | RMA | Tracking)</p>
        </div>
      ),
      dataIndex: "returnId",
      render: (returnId: any, data: any) => (
        <h1 className="px-2">
          {returnId}
          {data?.rmaNumber ? ` | ${data?.rmaNumber}` : ""}
          {data?.trackingCode ? ` | ${data?.trackingCode}` : ""}
        </h1>
      ),
    },
  ];

  const childOrderColumns = [
    {
      title: (
        <div className="flex items-center relative h-5 p-2 leading-3">
          <p className="mr-1">Order Id</p>
        </div>
      ),
      dataIndex: "orderId",
      render: (orderId: string) => (
        <Link
          to={{
            pathname: `/order/${orderId}`,
            state: { orderId },
          }}
        >
          <h1 className="cursor-pointer underline text-primary px-2">
            #{orderId}
          </h1>
        </Link>
      ),
    },
    {
      title: (
        <div className="flex items-center relative h-5 p-2 leading-3">
          <p className="mr-1">Status</p>
        </div>
      ),
      dataIndex: "partStatusId",
      render: (partStatusId: any) => {
        return (
          <h1 className="px-2">
            {
              orderStatus?.find((item: any) => item?.key === partStatusId)
                ?.value
            }
          </h1>
        );
      },
    },
    {
      title: (
        <div className="flex items-center relative h-5 p-2 leading-3">
          <p className="mr-1">Entry Date</p>
        </div>
      ),
      dataIndex: "entryDate",
      render: (entryDate: any) => {
        return (
          <h1 className="px-2">
            {moment(entryDate)?.format("YYYY-MM-DD hh:ss")}
          </h1>
        );
      },
    },
    {
      title: (
        <div className="flex items-center relative h-5 p-2 leading-3">
          <p className="mr-1">Approved Date</p>
        </div>
      ),
      dataIndex: "approvedDate",
      render: (approvedDate: any) => {
        return (
          <h1 className="px-2">
            {moment(approvedDate)?.format("YYYY-MM-DD hh:ss")}
          </h1>
        );
      },
    },
    {
      title: (
        <div className="flex items-center relative h-5 p-2 leading-3">
          <p className="mr-1">Total</p>
        </div>
      ),
      dataIndex: "partTotal",
      render: (partTotal: any) => {
        return <h1 className="px-2">{partTotal ?? 0.0}</h1>;
      },
    },
  ];

  const downloadLabel = async (url: any, shipmentId: any, filename?: string) => {
    if (shipmentId) {
      setIsLoading(true);
      await axios
        .get(url, {
          responseType: "arraybuffer",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/pdf",
          },
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename || `packing-${shipmentId}.pdf`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => console.log(error));
      setIsLoading(false);
    }
  };
  return (
    <>
      <div>
        <Loader
          isLoading={isLoading && isFirstTimeRendering}
          styles={{
            overlay: (base: any) => ({
              ...base,
              backgroundColor: "white",
            }),
          }}
        >
          <Modal
            title="Import Incoming shipment"
            visible={isModalOpen}
            footer={null}
            onCancel={() => {
              setShowUploadList(false);
              setIsModalOpen(false);
              setCsvFile(null);
              setIsLoading(false);
            }}
          >
            <Form
              form={importForm}
              onFinish={async (values: any) => {
                if (!csvFile || csvFile.status === "removed") {
                  notification["error"]({
                    message: "Error",
                    description: "Please select a CSV file!",
                  });
                  return;
                }
              }}
            >
              <Form.Item>
                <UploadFile
                  setCsvFile={setCsvFile}
                  isCloudIconVisible={true}
                  showUploadList={showUploadList}
                  setShowUploadList={setShowUploadList}
                />
              </Form.Item>
              <div
                className="flex items-center mb-3 cursor-pointer w-max"
                onClick={() => {
                  window.location.href =
                    process.env.REACT_APP_API_BASE_URL +
                    "/fp-static/downloadIncomingShipmentTemplate";
                }}
              >
                <DownloadOutlined style={{ fontSize: "18px" }} />
                <p className="ml-1 sm:ml-2 text-xs font-semibold text-primary">
                  DOWNLOAD CSV TEMPLATE
                </p>
              </div>
              <Form.Item>
                <div className="w-full mt-5 flex justify-end">
                  <Button
                    widthFull={true}
                    isDisabled={isDisabled}
                    buttonText="Inventory's On It's Way"
                  />
                </div>
              </Form.Item>
            </Form>
          </Modal>
          <Modal
            title="Update Item"
            visible={isUpdateModalOpen}
            footer={null}
            onCancel={() => {
              setIsUpdateModalOpen(false);
              updateForm?.resetFields();
            }}
          >
            <Loader
              isLoading={isForceLoading}
              styles={{
                overlay: (base: any) => ({
                  ...base,
                  backgroundColor: "",
                }),
              }}
            >
              <Form
                form={updateForm}
                onFinish={async (values: any) => {
                  delete values?.productName;
                  setIsForceLoading(true);
                  await dispatch(
                    updateOrderItem({
                      data: values,
                      orderId: id,
                      setIsUpdateModalOpen,
                      fetchData,
                      updateForm,
                    })
                  );
                  setIsForceLoading(false);
                }}
              >
                <div className="sm:flex">
                  <Form.Item name="productId" hidden></Form.Item>
                  <Form.Item name="orderItemSeqId" hidden></Form.Item>
                  <Form.Item
                    name="productName"
                    className="flex-1 w-full"
                    rules={[{ required: false, message: "Select an option!" }]}
                  >
                    <Input
                      title="Product"
                      placeholder="Product"
                      showDot={true}
                      isDisabled
                    />
                  </Form.Item>
                </div>
                <div className="sm:flex">
                  <Form.Item
                    name="quantity"
                    className="flex-1 w-full"
                    rules={[
                      {
                        required: true,
                        message: "Expected Quantity field is required!",
                      },
                      {
                        pattern: /^\d+$/,
                        message: "Please enter a valid number!",
                      },
                    ]}
                  >
                    <Input
                      title="Expected Quantity"
                      placeholder="Expected Quantity"
                      showDot={true}
                    />
                  </Form.Item>
                  {/* <Form.Item name="lotNumber" className="sm:mr-4 flex-1">
                <Input
                  title="Lot Number."
                  placeholder="Lot Number."
                  showDot={true}
                />
              </Form.Item> */}
                </div>
                {/* <div className="sm:flex">
                  <Form.Item
                    name="unitAmount"
                    className="flex-1 w-full"
                    rules={[
                      {
                        required: true,
                        message: "Unit Amount field is required",
                      },
                      {
                        pattern: /^\d+$/,
                        message: "Please enter a valid number",
                      },
                    ]}
                  >
                    <Input
                      title="Unit Amount"
                      placeholder="Unit Amount"
                      showDot={true}
                    />
                  </Form.Item>
                </div> */}
                {activeOrgStores?.some(
                  (data: any) =>
                    data?.productStoreId ===
                    orderDetailData?.order?.productStoreId &&
                    data?.itemProperties === "Y"
                ) && (
                    <div className="sm:flex">
                      <Form.Item name="itemProperties" className="flex-1 w-full">
                        <Dropdown
                          placeholder="Item Property"
                          title="Item Property"
                          data={itemPropertyEnumType}
                        />
                      </Form.Item>
                    </div>
                  )}
                <Form.Item>
                  <div className="w-full mt-5 flex justify-end">
                    <Button widthFull={true} buttonText="Update" />
                  </div>
                </Form.Item>
              </Form>
            </Loader>
          </Modal>
          <Modal
            title="Add Item"
            visible={isAddItemModalOpen}
            footer={null}
            onCancel={() => {
              setIsAddItemModalOpen(false);
              addForm?.resetFields();
              setProductList([]);
              setSelectedProduct(null);
            }}
          // width={700}
          >
            <Loader
              isLoading={false}
              styles={{
                overlay: (base: any) => ({
                  ...base,
                  backgroundColor: "",
                }),
              }}
            >
              <Form
                form={addForm}
                onFinish={async (values: any) => {
                  if (!selectedProduct) {
                    notification["error"]({
                      message: "Error",
                      description: "Please select a product.",
                    });
                    return;
                  }

                  const data = {
                    productId: selectedProduct,
                    quantity: values?.quantity,
                    orderId: id,
                    itemProperties: values?.itemproperty,
                    unitAmount: values?.unitAmount,
                  };
                  setIsForceLoading(true);

                  await dispatch(
                    addOrderItem({
                      data,
                      orderId: id,
                      setIsAddItemModalOpen,
                      fetchData,
                      setSelectedProduct,
                      addForm,
                    })
                  );
                  setIsForceLoading(false);
                }}
              >
                <div className="sm:flex">
                  <Form.Item
                    name="productId"
                    className="flex-1 w-full"
                    rules={[{ required: true, message: "Required" }]}
                  >
                    <div>
                      <h1 className="font-bold text-xs mb-0.5 sm:mb-1.5">
                        Product <span className="text-red-500">*</span>
                      </h1>
                      <Select
                        showSearch
                        value={selectedProduct}
                        placeholder="Search Product"
                        style={{ width: "100%" }}
                        defaultActiveFirstOption={false}
                        suffixIcon={null}
                        className={`border border-gray-400 py-1 w-full bg-white rounded-md focus:outline-none hover:border-primary-light focus:border-primary-light`}
                        filterOption={false}
                        onSearch={async (value) => {
                          setSearchableString(() => value);
                          setProductList([]);
                          debounceFn(
                            await dispatch(
                              searchProductListing({
                                productList,
                                setProductList,
                                setMaxPageIndex,
                                queryString: value,
                                currPage: 0,
                                setHasMoreProds,
                              })
                            )
                          );
                        }}
                        onSelect={(value: any) => {
                          setSelectedProduct(value);
                        }}
                        notFoundContent={null}
                        options={productList?.map((item: any) => {
                          const { identifications, productId, name } = item;
                          const sku = identifications?.find(
                            (iden: any) =>
                              iden?.productIdTypeEnumId === "PidtSku"
                          );
                          const upc = identifications?.find(
                            (iden: any) =>
                              iden?.productIdTypeEnumId === "PidtUpca"
                          );
                          const idValue =
                            sku?.idValue || upc?.idValue || productId || "";
                          return {
                            label: `${idValue}${name ? ` | ${name}` : ""}`,
                            value: item?.productId,
                          };
                        })}
                        onPopupScroll={async (e: any) => {
                          const { target } = e;
                          if (
                            (target as any).scrollTop +
                            (target as any).offsetHeight ===
                            (target as any).scrollHeight
                          ) {
                            if (!currIndex || currIndex * 1 === 0) {
                              return;
                            }
                            if (currIndex * 1 > maxPageIndex) {
                              return;
                            }
                            setCurrIndex((prev: any) => prev * 1 + 1);
                            localStorage.setItem(
                              "productListCurrIndex",
                              currIndex
                            );
                            await dispatch(
                              searchProductListing({
                                productList,
                                setProductList,
                                queryString: searchableString,
                                currPage: currIndex,
                                setHasMoreProds,
                              })
                            );
                          }
                        }}
                      />
                    </div>
                  </Form.Item>
                </div>
                <div className="sm:flex">
                  <Form.Item
                    name="quantity"
                    className="flex-1 w-full"
                    rules={[
                      {
                        required: true,
                        message: "Required*",
                      },
                      {
                        pattern: /^\d+$/,
                        message: "Please enter a valid number",
                      },
                    ]}
                  >
                    <Input
                      title="Quantity"
                      placeholder="Quantity"
                      showDot={true}
                      isRequired={true}
                    />
                  </Form.Item>
                </div><div className="sm:flex">
                  <Form.Item
                    name="unitAmount"
                    className="flex-1 w-full"
                    rules={[
                      {
                        required: true,
                        message: "Unit Amount field is required",
                      },
                      {
                        pattern: /^\d+$/,
                        message: "Please enter a valid number",
                      },
                    ]}
                  >
                    <Input
                      title="Unit Amount"
                      placeholder="Unit Amount"
                      showDot={true}
                    />
                  </Form.Item>
                </div>
                {activeOrgStores?.some(
                  (data: any) =>
                    data?.productStoreId ===
                    orderDetailData?.order?.productStoreId &&
                    data?.itemProperties === "Y"
                ) && (
                    <div className="sm:flex">
                      <Form.Item name="itemproperty" className="flex-1 w-full">
                        <Dropdown
                          placeholder="Item Property"
                          title="Item Property"
                          data={itemPropertyEnumType}
                        />
                      </Form.Item>
                    </div>
                  )}
                <Form.Item>
                  <div className="w-full mt-5 flex justify-end">
                    <Button
                      widthFull={true}
                      isDisabled={isForceLoading}
                      buttonText="Add"
                    />
                  </div>
                </Form.Item>
              </Form>
            </Loader>
          </Modal>
          {/* Update Shipment method */}
          <Modal
            title="Update Shipping method"
            visible={isShippingMethodModalOpen}
            footer={null}
            onCancel={() => {
              setIsShippingMethodModalOpen(false);
              updateForm?.resetFields();
            }}
          >
            <Loader
              isLoading={isForceLoading}
              styles={{
                overlay: (base: any) => ({
                  ...base,
                  backgroundColor: "",
                }),
              }}
            >
              <Form
                form={shippingMethodForm}
                onFinish={async (values: any) => {
                  const selectedMethod: any = shippingMethods?.find(
                    (item: any) =>
                      values?.ShipmentMethodEnumId ===
                      `${item?.carrierPartyId}${item?.shipmentMethodEnumId}`
                  );
                  setIsForceLoading(true);
                  await dispatch(
                    updateShipmentShippingMethod({
                      shipmentId: values?.shipmentId,
                      carrierPartyId: selectedMethod?.carrierPartyId,
                      shipmentMethodEnumId:
                        selectedMethod?.shipmentMethodEnumId,
                      setIsShippingMethodModalOpen,
                      fetchData,
                    })
                  );
                  setIsForceLoading(false);
                }}
              >
                <Form.Item name="shipmentId" hidden></Form.Item>
                <Form.Item
                  name="ShipmentMethodEnumId"
                  rules={[
                    {
                      required: true,
                      message: "Shipment method field is required",
                    },
                  ]}
                >
                  <Dropdown
                    searchable={true}
                    placeholder="Select One"
                    data={shippingMethods?.map((s: any) => {
                      return {
                        key: `${s?.carrierPartyId}${s?.shipmentMethodEnumId}`,
                        value: s?.description,
                      };
                    })}
                  />
                </Form.Item>
                <Form.Item>
                  <div className="w-full mt-5 flex justify-end">
                    <Button widthFull={true} buttonText="Update" />
                  </div>
                </Form.Item>
              </Form>
            </Loader>
          </Modal>
          {/* Edit Ship To Address */}
          <Modal
            title="Edit Ship To Address"
            visible={isEditAddressModalOpen}
            footer={null}
            onCancel={() => {
              setIsEditAddressModalOpen(false);
              editAddressForm?.resetFields();
            }}
          >
            <Loader
              isLoading={isForceLoading}
              styles={{
                overlay: (base: any) => ({
                  ...base,
                  backgroundColor: "",
                }),
              }}
            >
              <Form
                form={editAddressForm}
                onFinish={async (values: any) => {
                  setIsForceLoading(true);
                  await dispatch(
                    updateOrderShippingAddress({
                      orderId: id,
                      orderPartSeqId:
                        currentOrderPart?.orderPart?.orderPartSeqId || "01",
                      fullName: values?.name,
                      attnName: values?.attnName,
                      address1: values?.address1,
                      unitNumber: values?.unitNumber,
                      address2: values?.address2,
                      city: values?.city,
                      stateCode: values?.state,
                      postalCode: values?.postalCode,
                      postalCodeExt: values?.postalCodeExt,
                      countryGeoId: values?.country,
                      countryCode: values?.countryCode,
                      areaCode: values?.areaCode,
                      contactNumber: values?.contactNumber,
                      telecomExtension: values?.telecomExtension,
                      emailAddress: values?.email,
                      setIsEditAddressModalOpen,
                      fetchData,
                    })
                  );
                  setIsForceLoading(false);
                }}
              >
                <Form.Item
                  name="name"
                  rules={[{ required: true, message: "Name is required!" }]}
                >
                  <Input title="To Name" placeholder="To Name" showDot={true} />
                </Form.Item>
                <Form.Item name="attnName">
                  <Input title="Attention" placeholder="Attention" showDot={false} />
                </Form.Item>
                <div className="sm:flex">
                  <Form.Item
                    className="sm:mr-4 flex-1"
                    name="address1"
                    rules={[
                      { required: true, message: "Address 1 is required!" },
                    ]}
                  >
                    <Input
                      title="Address 1"
                      placeholder="Address 1"
                      showDot={true}
                    />
                  </Form.Item>
                  <Form.Item className="sm:w-24" name="unitNumber">
                    <Input title="Unit" placeholder="Unit" showDot={false} />
                  </Form.Item>
                </div>
                <Form.Item name="address2">
                  <Input title="Address 2" placeholder="Address 2" showDot={false} />
                </Form.Item>
                <div className="sm:flex">
                  <Form.Item
                    className="sm:mr-4 flex-1"
                    name="city"
                    rules={[{ required: true, message: "City is required!" }]}
                  >
                    <Input title="City" placeholder="City" showDot={true} />
                  </Form.Item>
                  <Form.Item
                    className="sm:mr-4 flex-1"
                    name="postalCode"
                    rules={[
                      { required: true, message: "Postal Code is required!" },
                    ]}
                  >
                    <Input
                      title="Zip / Postal Code"
                      placeholder="Zip"
                      showDot={true}
                    />
                  </Form.Item>
                  <Form.Item className="sm:w-24" name="postalCodeExt">
                    <Input title="Ext" placeholder="Ext" showDot={false} />
                  </Form.Item>
                </div>
                <div className="sm:flex">
                  <Form.Item
                    className="sm:mr-4 flex-1"
                    name="country"
                    rules={[{ required: true, message: "Select an option!" }]}
                  >
                    <Dropdown
                      placeholder="Country"
                      data={countriesList}
                      onChange={selectEditAddressCountry}
                      searchable={true}
                    />
                  </Form.Item>
                  <Form.Item className="flex-1" name="state">
                    <Dropdown
                      placeholder="State"
                      data={[{ key: "_NA_", value: "_NA_" }, ...statesList]}
                      searchable={true}
                    />
                  </Form.Item>
                </div>
                <h1 className="font-bold text-xs mb-0.5 sm:mb-1.5">Phone</h1>
                <div className="flex gap-2">
                  <Form.Item className="w-16" name="countryCode">
                    <Input title="" placeholder="+1" showDot={false} />
                  </Form.Item>
                  <Form.Item className="w-20" name="areaCode">
                    <Input title="" placeholder="Area" showDot={false} />
                  </Form.Item>
                  <Form.Item className="flex-1" name="contactNumber">
                    <Input title="" placeholder="Number" showDot={false} />
                  </Form.Item>
                  <Form.Item className="w-20" name="telecomExtension">
                    <Input title="" placeholder="Ext" showDot={false} />
                  </Form.Item>
                </div>
                <Form.Item
                  name="email"
                  rules={[
                    { type: "email", message: "Enter a valid email!" },
                  ]}
                >
                  <Input title="Email" placeholder="Email" showDot={false} />
                </Form.Item>
                <Form.Item>
                  <div className="w-full mt-5 flex justify-end">
                    <Button widthFull={true} buttonText="Update" />
                  </div>
                </Form.Item>
              </Form>
            </Loader>
          </Modal>
          <Modal
            title="Add Attachment"
            visible={isDocumentModalOpen}
            footer={null}
            onCancel={() => {
              setShowUploadList(false);
              setIsDocumentModalOpen(false);
              setFile(null);
              uploadDocumentForm?.resetFields();
              setIsLoading(false);
            }}
          >
            <Loader
              isLoading={isForceLoading}
              styles={{
                overlay: (base: any) => ({
                  ...base,
                  backgroundColor: "",
                }),
              }}
            >
              <Form
                form={uploadDocumentForm}
                onFinish={async (values: any) => {
                  if (!file || file?.status === "removed") {
                    notification["error"]({
                      message: "Error",
                      description: "Please select a file!",
                    });
                    return;
                  }

                  const formData = new FormData();
                  file.forEach((f: any) => {
                    // console.log("f.originFileObj", f?.originFileObj);
                    formData.append("contentFile", f?.originFileObj);
                  });
                  formData.append("description", values?.description ?? "");
                  formData.append("orderId", id);
                  setIsForceLoading(true);
                  await dispatch(
                    addOrderAttachment({
                      formData,
                      fetchData,
                      setIsDocumentModalOpen,
                    })
                  );
                  uploadDocumentForm?.resetFields();
                  setIsForceLoading(false);
                  setFile(null);
                  setShowUploadList(false);
                }}
              >
                <Form.Item name="description" className="flex-1 w-full">
                  <Input
                    title="Description"
                    placeholder="Description"
                    showDot={true}
                  />
                </Form.Item>
                <Form.Item>
                  <UploadDocument
                    setFile={setFile}
                    isCloudIconVisible={true}
                    showUploadList={showUploadList}
                    setShowUploadList={setShowUploadList}
                    multiple
                    fileList={file}
                  />
                </Form.Item>

                <Form.Item>
                  <div className="w-full mt-5 flex justify-end">
                    <Button
                      widthFull={true}
                      isDisabled={isDisabled}
                      buttonText="Add"
                    />
                  </div>
                </Form.Item>
              </Form>
            </Loader>
          </Modal>
          {/*Upload Item or Import Item File Modal*/}

          <Modal
            visible={isUploadModalOpen}
            onCancel={() => setIsUploadModalOpen(false)}
            footer={null}
            title="Upload Item CSV"
            width={600}
          >
            <Loader isLoading={isLoading} styles={{
              overlay: (base: any) => ({
                ...base,
                backgroundColor: "white",
              }),
            }}>
            <Form
              form={mapForm}
              name="upload_form"
              onFinish={async () => {
                if (!csvFileForOrder) {
                  notification.error({
                    message: "Error",
                    description: "Please select a CSV file!",
                  });
                  return;
                }
                setIsLoading(true);
                let formData = new FormData();
                const organizationPartyId: any = localStorage.getItem(
                  "organizationPartyId"
                );
                const orderPartSequenceId = shipmentDetails?.orderPart?.orderPartSeqId ?? "01"
                formData.append("orderPartSeqId", orderPartSequenceId);
                formData.append("templateId", "Order_Items_Data_Import");
                formData.append("orderId", orderId);
                formData.append("contentFile", csvFileForOrder);
                formData.append("ownerPartyId", organizationPartyId);

                await dispatch(
                  importData({ data: formData, history })
                );
                fetchData()
                setIsLoading(false);
                setShouldRerender(true)
                setShowUploadList(false);
                setIsUploadModalOpen(false);
              }}
            >
              {/* Upload File */}
              <Form.Item>
                <UploadFile
                  setCsvFile={setCsvFileForOrder}
                  isCloudIconVisible={true}
                  showUploadList={showUploadList}
                  setShowUploadList={setShowUploadList}
                />
              </Form.Item>
              {/* Uploading progress */}
              {isUploading && (
                <div className="mb-5">
                  <h1 className="font-semibold text-sm mb-1.5">Uploading...</h1>
                  <ProgressBar
                    completed={uploadCompletionRate}
                    height="7px"
                    borderRadius="0px"
                    bgColor={
                      importStatus === "DataImportFailed" ||
                        importStatus === "DataImportHeaderMatchFailed"
                        ? "#e22426"
                        : "#57bb54"
                    }
                    isLabelVisible={false}
                  />

                  {/* Status messages */}
                  {importStatus === "DataImportSuccess" ? (
                    <h1 className="mt-3 text-green-600">
                      Success! You can review and finalize your order on the next page.
                    </h1>
                  ) : importStatus === "DataImportFailed" ? (
                    <h1 className="mt-3 text-red-600">
                      Something went wrong during upload. Download results to see the errors.
                    </h1>
                  ) : importStatus === "DataImportHeaderMatchFailed" ? (
                    <h1 className="mt-3 text-red-600">Upload Failed.</h1>
                  ) : (
                    ""
                  )}
                </div>
              )}

              {/* VIEW ERROR FILE */}
              {importStatus === "DataImportFailed" && (
                <div
                  className="flex items-center mb-6 cursor-pointer w-max"
                  onClick={() => {
                    window.location.href =
                      process.env.REACT_APP_API_BASE_URL +
                      `/rest/s1/fp/order/downloadOrderItemResultFile?importId=${importId}`;
                  }}
                >
                  <DownloadOutlined style={{ fontSize: "18px" }} />
                  <p className="ml-1 sm:ml-2 text-xs font-semibold text-primary">
                    VIEW ERRORS
                  </p>
                </div>
              )}

              {/* Templates */}
              <div className="flex items-center">
                <div
                  className="flex items-center mb-3 mt-2 mr-3 cursor-pointer w-max"
                  onClick={() => {
                    window.location.href =
                      process.env.REACT_APP_API_BASE_URL +
                      "/fp-static/downloadTemplate?template=order_item_template.xlsx";
                  }}
                >
                  <DownloadOutlined style={{ fontSize: "18px" }} />
                  <p className="ml-1 sm:ml-2 text-xs font-semibold text-primary">
                    DOWNLOAD XLSX TEMPLATE
                  </p>
                </div>
                <div
                  className="flex items-center mb-3 mt-2 cursor-pointer w-max"
                  onClick={() => {
                    window.location.href =
                      process.env.REACT_APP_API_BASE_URL +
                      "/fp-static/downloadOrderItemTemplate";
                  }}
                >
                  <DownloadOutlined style={{ fontSize: "18px" }} />
                  <p className="ml-1 sm:ml-2 text-xs font-semibold text-primary">
                    DOWNLOAD CSV TEMPLATE
                  </p>
                </div>
              </div>
              {/* Import Button */}
              <Button
                buttonText="Submit"
                classNames="mt-4"
              // onClick={() => mapForm.submit()}
              />
            </Form>
            </Loader>
          </Modal>

          <div
            className="flex flex-row items-center mb-6 cursor-pointer w-max"
            onClick={() => {
              history.push("/order/orderListing");
            }}
          >
            <MdOutlineKeyboardBackspace
              style={{ fontSize: "20px" }}
              className="text-primary"
            />
            <p className="ml-1 sm:ml-2 text-xs font-bold text-primary">
              BACK TO RESULTS
            </p>
          </div>
          <div className="flex flex-col mdlarge:flex-row mb-3">
            <div className="w-full mdlarge:w-8/12 mr-0 mdlarge:mr-3">
              <div>
                <div className="bg-white p-5 rounded-lg shadow-sm">
                  <span className="text-base sm:text-lg font-bold mr-5">
                    Order ID # {orderId}
                  </span>
                  <span className="text-gray-500 block ltmob:inline">
                    {placedDate}
                  </span>
                </div>
              </div>
              {customerContact ? (
                <div className="bg-white p-5 pb-6 mb-6 rounded-lg shadow-sm mt-6">
                  <div className="flex flex-row items-center justify-between">
                    <h1 className="text-base font-bold mr-3 mb-4">
                      Customer Contact
                    </h1>
                    {isShippingAddressEditable && (
                      <BiEdit
                        className="mb-4 cursor-pointer text-lg font-semibold text-primary"
                        onClick={openEditAddressModal}
                      />
                    )}
                  </div>
                  {orderDetailData?.order?.parts &&
                    orderDetailData?.order?.parts.length > 0 &&
                    displayPostalAddress?.toName && (
                      <div className="flex flex-row items-center mb-4">
                        <HiOutlineUser size={23} />
                        <h1 className="text-primary text-xs font-bold ml-3">
                          {displayPostalAddress?.toName}
                        </h1>
                      </div>
                    )}
                  {orderDetailData?.order?.parts &&
                    orderDetailData?.order?.parts.length > 0 &&
                    displayPostalAddress &&
                    displayPostalAddress?.attnName && (
                      <div className="flex flex-row items-center mb-4">
                        <BiErrorCircle size={23} />
                        <h1 className="ml-2.5">
                          {displayPostalAddress?.attnName}
                        </h1>
                      </div>
                    )}
                  {orderDetailData?.order?.parts &&
                    orderDetailData?.order?.parts.length > 0 &&
                    displayPostalAddress && (
                      <div className="flex flex-row mb-4">
                        <GoLocation size={22} />
                        <div className="ml-2.5">
                          <h1>
                            {displayPostalAddress?.address1}{" "}
                            {displayPostalAddress?.address2 && `,`}
                          </h1>
                          <h1>{displayPostalAddress?.address2}</h1>
                          <h1>
                            {displayPostalAddress?.city}
                            {displayStateGeo?.geoCodeAlpha2
                              ? `, ${displayStateGeo?.geoCodeAlpha2}`
                              : ", --"}
                            {displayPostalAddress?.countryGeoId &&
                              `, ${displayPostalAddress?.countryGeoId}`}
                            {displayPostalAddress?.postalCodeExt &&
                              `, ${displayPostalAddress?.postalCodeExt} -`}
                            {displayPostalAddress?.postalCode &&
                              ` ${displayPostalAddress?.postalCode}`}
                          </h1>
                        </div>
                      </div>
                    )}
                  {orderDetailData?.order?.parts &&
                    orderDetailData?.order?.parts.length > 0 &&
                    displayTelecomNumber && (
                      <div className="flex flex-row items-center mb-4">
                        <HiOutlinePhone size={23} />
                        <h1 className="ml-2.5">
                          {displayTelecomNumber?.countryCode &&
                            `(${displayTelecomNumber?.countryCode}) `}
                          {displayTelecomNumber?.areaCode &&
                            `${displayTelecomNumber?.areaCode}-`}
                          {displayTelecomNumber?.contactNumber &&
                            `${displayTelecomNumber?.contactNumber}`}
                        </h1>
                      </div>
                    )}
                  {displayEmail && (
                    <div className="flex flex-row items-center mb-4">
                      <HiOutlineMail size={23} />
                      <h1 className="text-primary text-xs font-bold ml-3">
                        {displayEmail}
                      </h1>
                    </div>
                  )}
                  {!displayEmail &&
                    orderDetailData?.order?.parts &&
                    orderDetailData?.order?.parts.length > 0 &&
                    orderDetailData?.order?.parts[0]?.customerEmail && (
                      <div className="flex flex-row items-center mb-4">
                        <HiOutlineMail size={23} />
                        <h1 className="text-primary text-xs font-bold ml-3">
                          {orderDetailData?.order?.parts[0]?.customerEmail}
                        </h1>
                      </div>
                    )}
                  {shipmentDetails &&
                    shipmentDetails.partPaymentInfoList &&
                    shipmentDetails.partPaymentInfoList[0] ? (
                    <div>
                      <div className="mt-5">
                        <span className="font-bold mr-3 text-base">
                          Paid Via
                        </span>
                        <span>
                          {customerContact && customerContact.dataSourceId
                            ? customerContact && customerContact.dataSourceId
                            : ""}
                        </span>
                      </div>
                      <div className="mt-3 ml-6">
                        {paymentList &&
                          paymentList[0] &&
                          paymentList[0].value ? (
                          <h1 className="text-xs font-medium">
                            {paymentList && paymentList[0]
                              ? dateConvert(
                                paymentList &&
                                paymentList[0] &&
                                paymentList[0].value
                              ) +
                              " " +
                              timeConvert(
                                paymentList &&
                                paymentList[0] &&
                                paymentList[0].value
                              )
                              : ""}
                          </h1>
                        ) : (
                          ""
                        )}
                        {paymentList &&
                          paymentList[1] &&
                          paymentList[1].value ? (
                          <h1 className="text-xs font-medium">
                            Ref:{" "}
                            {paymentList &&
                              paymentList[1] &&
                              paymentList[1].value}
                          </h1>
                        ) : (
                          ""
                        )}

                        <h1 className="text-xs font-medium">{ }</h1>

                        <h1 className="text-xs font-medium">
                          $:
                          {paymentList &&
                            paymentList[2] &&
                            paymentList[2].value}
                        </h1>
                        <h1 className="text-xs font-medium">
                          {paymentList &&
                            paymentList[3] &&
                            paymentList[3].value}
                        </h1>
                      </div>
                    </div>
                  ) : (
                    <div></div>
                  )}
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="w-full mdlarge:w-[55%] ml-0 mdlarge:ml-3 mt-6 mdlarge:mt-0">
              <div className="bg-white p-5 pb-6 rounded-lg shadow-sm mb-6">
                <div className="flex flex-row items-center mb-2">
                  <h1 className="text-base font-bold mr-3">Order Info</h1>
                  {/* <div
                    className="flex items-center cursor-pointer w-max"
                    // onClick={downloadCsv}
                  >
                    <RiDownloadLine style={{ fontSize: "16px" }} />
                    <p className="ml-1 sm:ml-2 text-xs font-bold text-primary">
                      DOWNLOAD CSV
                    </p>
                  </div> */}
                  <div className="flex flex-wrap items-center gap-2 py-4">
                    <Button
                      buttonText="Approve"
                      isDisabled={
                        shipmentGridDetail &&
                          shipmentGridDetail?.length === 0 &&
                          ![
                            "OrderCancelled",
                            "OrderCompleted",
                            "OrderApproved",
                          ].includes(orderDetailData?.order?.statusId) &&
                          orderDetailData?.order?.orderItems?.length > 0
                          ? false
                          : true
                      }
                      onClick={() => {
                        confirm({
                          title: "Are you sure?",
                          icon: "",
                          content: "Do you want to approve this order?",
                          okText: "Yes",
                          cancelText: "No",
                          onOk: async () => {
                            await dispatch(
                              orderApprove({
                                orderId: id,
                                fetchData,
                              })
                            );
                          },
                          onCancel() {
                            // console.log("Cancel");
                          },

                          okButtonProps: {
                            className: "rounded-lg text-white font-semibold",
                          },
                          cancelButtonProps: {
                            className: "rounded-lg",
                          },
                        });
                      }}
                      style={{
                        backgroundColor: "#1e107b",
                        borderColor: "#1e107b",
                        opacity:
                          shipmentGridDetail &&
                            shipmentGridDetail?.length === 0 &&
                            ![
                              "OrderCancelled",
                              "OrderCompleted",
                              "OrderApproved",
                            ].includes(orderDetailData?.order?.statusId) &&
                            orderDetailData?.order?.orderItems?.length > 0
                            ? 1
                            : 0.5,
                      }}
                      classNames="rounded-md px-1 py-1"
                    />
                    <Button
                      buttonText="Hold"
                      isDisabled={
                        shipmentGridDetail &&
                          shipmentGridDetail?.length === 0 &&
                          !["OrderCancelled", "OrderHold"].includes(
                            orderDetailData?.order?.statusId
                          )
                          ? false
                          : true
                      }
                      onClick={() => {
                        confirm({
                          title: "Are you sure?",
                          icon: "",
                          content: "Do you want to hold this order?",
                          okText: "Yes",
                          cancelText: "No",
                          onOk: async () => {
                            await dispatch(
                              orderHoldStatus({
                                orderId: id,
                                statusId: "OrderHold",
                                fetchData,
                              })
                            );
                          },
                          onCancel() {
                            // console.log("Cancel");
                          },

                          okButtonProps: {
                            className: "rounded-lg text-white font-semibold",
                          },
                          cancelButtonProps: {
                            className: "rounded-lg",
                          },
                        });
                      }}
                      style={{
                        backgroundColor: "#1e107b",
                        borderColor: "#1e107b",
                        opacity:
                          shipmentGridDetail &&
                            shipmentGridDetail?.length === 0 &&
                            !["OrderCancelled", "OrderHold"].includes(
                              orderDetailData?.order?.statusId
                            )
                            ? 1
                            : 0.5,
                      }}
                      classNames="rounded-md px-1 py-1"
                    />
                    <Button
                      isDisabled={
                        shipmentGridDetail &&
                          shipmentGridDetail?.length === 0 &&
                          orderDetailData?.order?.statusId !== "OrderCancelled"
                          ? false
                          : true
                      }
                      onClick={() => {
                        confirm({
                          title: "Are you sure?",
                          icon: "",
                          content: "Do you want to cancel this order?",
                          okText: "Yes",
                          cancelText: "No",
                          onOk: async () => {
                            await dispatch(
                              cancelOrder({ orderId: id, fetchData })
                            );
                          },
                          onCancel() {
                            // console.log("Cancel");
                          },
                          okButtonProps: {
                            className: "rounded-lg text-white font-semibold",
                          },
                          cancelButtonProps: {
                            className: "rounded-lg",
                          },
                        });
                      }}
                      style={{
                        backgroundColor: "#ffc107",
                        borderColor: "#ffc107",
                        color: "#212529",
                        opacity:
                          shipmentGridDetail &&
                            shipmentGridDetail?.length === 0 &&
                            orderDetailData?.order?.statusId !== "OrderCancelled"
                            ? 1
                            : 0.5,
                      }}
                      buttonText="Cancel"
                      classNames="rounded-md px-1 py-1 "
                    />
                    {orderDetailData?.order?.statusId === "OrderHold" && (
                      <Button
                        onClick={() => {
                          confirm({
                            title: "Are you sure?",
                            icon: "",
                            content: "Do you want to split this order?",
                            okText: "Yes",
                            cancelText: "No",
                            onOk: async () => {
                              await dispatch(
                                splitOrder({ orderId: id, fetchData })
                              );
                            },
                            okButtonProps: {
                              className: "rounded-lg text-white font-semibold",
                            },
                            cancelButtonProps: {
                              className: "rounded-lg",
                            },
                          });
                        }}
                        buttonText="Split"
                        classNames="rounded-md px-1 py-1 "
                      />
                    )}
                  </div>
                </div>
                <div className="border-b border-gray-300">
                  <div className="flex flex-wrap gap-10 items-center pb-6 mt-2">
                    <h1
                      className={`text-base font-bold ${orderDetailData?.order?.returnInfo && "mb-8"
                        }`}
                    >
                      Status
                    </h1>
                    <div
                      className={`${!orderDetailData?.order?.returnInfo
                        ? "flex flex-col"
                        : "flex flex-col gap-1"
                        }`}
                    >
                      <label
                        style={{
                          backgroundColor: "#093479",
                          outlineColor: "#707070",
                          border: "1px solid #707070",
                        }}
                        htmlFor=""
                        className="px-1.5 py-1 text-xs text-white tracking-wider border font-semibold rounded-md w-max"
                      >
                        {
                          orderStatus?.find(
                            (item: any) =>
                              item?.key === orderDetailData?.order?.statusId
                          )?.value
                        }
                      </label>
                      {orderDetailData?.order?.returnInfo?.length > 0 && (
                        <div className="flex items-center">
                          <h1
                            onClick={() =>
                              collapseRef?.current?.scrollIntoView({
                                behavior: "smooth",
                                block: "start",
                              })
                            }
                            style={{
                              backgroundColor: "#F93D6F",
                              outlineColor: "#707070",
                              border: "1px solid #707070",
                              margin: 0,
                            }}
                            className="px-2 py-0.3 text-md mr-5 text-white tracking-wider border font-semibold rounded-md cursor-pointer"
                          >
                            Returned
                          </h1>
                          <p
                            style={{
                              fontSize: "30px",
                              fontWeight: "bold",
                              margin: 0,
                            }}
                          >
                            <MdOutlineNavigateNext />
                          </p>
                        </div>
                      )}
                    </div>
                    {/* {currStatus !== "OrderHeld" &&
                    currStatus !== "OrderCompleted" && (
                      <button
                        className="ml-2 vxsmall:ml-5 px-9 text-xs sm:px-4 sm:text-sm bg-primary hover:shadow-custom-btn hover:text-btn-text-hover focus:outline-none text-white font-semibold py-2 mt-1 rounded-lg"
                        // onClick={async () => {
                        //   setIsLoading(true);
                        //   await dispatch(
                        //     updateStatusInfo({
                        //       statusId: currStatus,
                        //       orderId: id,
                        //       setStatusOnSave,
                        //     })
                        //   );
                        //   setIsLoading(false);
                        // }}
                      >
                        Save
                      </button>
                    )} */}
                  </div>
                  {orderDetailData?.order?.displayId &&
                    orderDetailData?.order?.displayId !== "undefined" && (
                      <h1 className="mb-2">
                        Display ID: {orderDetailData?.order?.displayId}
                      </h1>
                    )}
                  {orderDetailData?.order?.segmentation &&
                    orderDetailData?.order?.segmentation !== "undefined" && (
                      <h1 className="mb-2">
                        Segmentation: {orderDetailData?.order?.segmentation}
                      </h1>
                    )}
                </div>
                <div className="flex flex-row items-center justify-between my-6">
                  <div className="flex flex-row items-center">
                    <h1 className="text-sm font-semibold mr-3">Subtotal</h1>
                    <h1 className="text-gray-500">
                      (
                      {(subTotal && subTotal[1] && subTotal[1].value === 1) ||
                        (subTotal && subTotal[1] && subTotal[1].value === 0)
                        ? `${subTotal && subTotal[1] && subTotal[1].value} item`
                        : `${subTotal && subTotal[1] && subTotal[1].value
                        } items`}
                      )
                    </h1>
                  </div>

                  <h1>${subTotal && subTotal[0] && subTotal[0].value}</h1>
                </div>
                {shipping ? (
                  <div className="flex flex-row items-center justify-between mt-5">
                    <div>
                      <h1 className="text-sm font-semibold mr-3">Shipping</h1>
                      {/* <h1 className='text-gray-500 ml-5'>Next Day Shipping (0.87lbs)</h1> */}
                      <h1 className="text-gray-500 ml-5">
                        {shipping && shipping[1].value}
                      </h1>
                    </div>
                    <h1 className="mt-4">
                      {shipping ? "$" : ""}
                      {shipping && shipping[0].value}
                    </h1>
                  </div>
                ) : (
                  ""
                )}
                {salesTax && salesTax[2] && salesTax[2].value.length > 0 ? (
                  <div className="flex flex-row items-center justify-between mt-5">
                    <div>
                      <h1 className="text-sm font-semibold mr-3">Tax</h1>
                      {salesTax &&
                        salesTax[2] &&
                        salesTax[2].value.map((item: any) => {
                          if (item)
                            return (
                              <h1 className="text-gray-500 ml-5 ">{item}</h1>
                            );
                          return null;
                        })}
                    </div>
                    <div className="flex flex-col mt-6">
                      {salesTax &&
                        salesTax[0] &&
                        salesTax[0].value.map((item: any) => {
                          if (item)
                            return (
                              <h1 className="text-gray-500 ml-5 text-right">
                                ${Number(item).toFixed(2)}
                              </h1>
                            );
                          return null;
                        })}
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {discount && discount > 0 ? (
                  <div className="flex flex-row items-center justify-between mt-5">
                    <h1 className="text-sm font-semibold mr-3">Discounts</h1>
                    <h1>-${discount.toFixed(2)}</h1>
                  </div>
                ) : null}

                <div className="flex flex-row items-center justify-between mt-5">
                  <h1 className="text-base font-bold">Total</h1>
                  <h1 className="text-base font-bold">
                    ${Number(grandTotal ?? 0)?.toFixed(2)}
                  </h1>
                </div>
                <div className="mt-5 flex flex-row items-center">
                  <h1 className="font-bold">Total units:</h1>
                  <h1 className="ml-1">{totalQty}</h1>
                </div>
                {orderDetailData?.order?.totalEstimatedAmount ? (
                  <div className="mt-2 flex flex-row items-center">
                    <h1 className="font-bold">Shipping label cost:</h1>
                    <h1 className="ml-1">
                      $
                      {orderDetailData?.order?.totalEstimatedAmount?.toFixed(2)}
                    </h1>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          <Collapse
            // defaultActiveKey={["1"]}
            className="bg-white p-2 rounded-lg shadow-sm mt-5 mb-5"
            collapsible="header"
            ghost
          >
            <Panel
              header={<h1 className="font-bold text-base">Attachments</h1>}
              key="1"
            >
              <div className="flex justify-between items-center">
                <h1 className="mb-4 font-bold text-base"></h1>
                <Button
                  onClick={() => setIsDocumentModalOpen(true)}
                  buttonText="Add Attachment"
                  classNames="mb-4"
                />
              </div>
              <Table
                rowKey="shipMethod"
                dataSource={orderDetailData?.order?.orderAttachmentList
                  ?.filter((item: any) => !item?.thruDate)
                  ?.sort((a: any, b: any) => {
                    const dateA = moment(a?.contentDate).valueOf();
                    const dateB = moment(b?.contentDate).valueOf();
                    return dateB - dateA;
                  })}
                columns={orderAttachmentColumns}
                isPaginated={false}
              />
            </Panel>
          </Collapse>
          {shipmentGridDetail &&
            shipmentGridDetail.length === 0 &&
            !["OrderApproved", "Completed", "Cancelled"].includes(
              orderDetailData?.order?.statusId
            ) && (
              <div className="mt-5">
                <div className="flex justify-between">
                  <div className="mb-4">
                    <Button
                      onClick={() => setIsAddItemModalOpen(true)}
                      buttonText="Add Item"
                      classNames="ml-2"
                    />
                    <Button
                      buttonText="Upload Items"
                      classNames="ml-2"
                      onClick={() => setIsUploadModalOpen(true)}
                    />
                  </div>
                </div>
              </div>
            )}

          {/*Order History Table of Uploading Bulk Items */}
          {orderDetailData?.order?.statusId === "OrderPlaced" && (
            <Collapse
              className="bg-white p-2 rounded-lg shadow-sm mt-2"
              collapsible="header"
              ghost
            >
              <Panel
                header={<h1 className="font-bold text-base">Item Upload History</h1>}
                key="1"
              >
                <div>
                  <ImportListing
                    importType="Order_Items_Data_Import"
                    showLoader={false}
                    setShouldRerender={setShouldRerender}
                    shouldRerender={shouldRerender}
                    orderId={orderId}
                  />
                </div>
              </Panel>
            </Collapse>
          )}

          <div className="bg-white p-5 pb-0.5 rounded-lg shadow-sm mt-4">
            <h1 className="mb-4 font-bold text-base">Items</h1>
            <Table
              rowKey="shipMethod"
              dataSource={orderItems}
              columns={columns}
              isPaginated={false}
              rowClassName={(record: any) => {
                const isMatched =
                  orderDetailData?.order?.overAllocatedOrderItems?.some(
                    (item: any) =>
                      item.some(
                        (subItem: any) =>
                          subItem?.productId === record?.productId ||
                          record?.componentProductList?.find(
                            (data: any) =>
                              data?.componentProductId === subItem?.productId &&
                              data?.orderItemSeqId === subItem?.orderItemSeqId
                          )
                      )
                  );
                return isMatched ? "ant-row-color" : "";
              }}
            />
          </div>
          {childOrderdata?.length > 0 && (
            <Collapse
              // defaultActiveKey={["1"]}
              className="bg-white p-2 rounded-lg shadow-sm mt-5 mb-5"
              collapsible="header"
              ghost
            >
              <Panel
                header={
                  <h1 className="font-bold text-base"> Child/Cloned Orders</h1>
                }
                key="1"
              >
                <Table
                  rowKey="shipMethod"
                  dataSource={childOrderdata}
                  columns={childOrderColumns}
                  isPaginated={false}
                />
              </Panel>
            </Collapse>
          )}
          {shipmentGridDetail && shipmentGridDetail.length > 0 ? (
            <div>
              {shipmentGridDetail &&
                shipmentGridDetail.length > 0 &&
                shipmentGridDetail.map((item: any, index: any) => {
                  return (
                    <div className="bg-white rounded-lg shadow-sm p-5 pb-6  mt-6 ">
                      <div className="mb-4">
                        <span className="mr-2 font-bold text-lg">
                          Shipment {index + 1}
                          {": "}
                          {`${shipmentStatus?.find(
                            (data: any) => data?.key === item?.statusId
                          )?.value
                            }`}
                        </span>

                        {/* <span className='text-gray-600'>Items (01-05)</span> */}
                        {!palletShipments[item?.shipmentId] && (
                          <span className="text-gray-600 ml-2">
                            <Button
                              buttonText={
                                <div>
                                  <DownloadOutlined
                                    className="mr-1"
                                    style={{ fontSize: 20 }}
                                  />
                                  Packing Slip
                                </div>
                              }
                              paddingX="px-2"
                              paddingY="py-1"
                              isLoading={packingSlipDownloading}
                              onClick={async () => {
                                try {
                                  setPackingSlipDownloading(true)
                                  const url = `${process.env.REACT_APP_API_BASE_URL}/fop/apps/PopcAdmin/Shipping/ShipmentInsert?shipmentId=${item?.shipmentId}`;
                                  await downloadLabel(url, item?.shipmentId, 'packing');
                                } catch (e) { console.error(e) }
                                finally {
                                  setPackingSlipDownloading(false)
                                }
                              }}
                              defaultColor="bg-blue-800"
                            />
                          </span>
                        )}
                        {!!palletShipments[item?.shipmentId] && (
                          <span className="text-gray-600 ml-2">
                            <Button
                              buttonText={
                                <div>
                                  <DownloadOutlined className="mr-1" style={{ fontSize: 20 }} />
                                  Packing List
                                </div>
                              }
                              paddingX="px-2"
                              paddingY="py-1"
                              isLoading={packingListDownloading}
                              onClick={async () => {
                                try {
                                  setPackingListDownloading(true)
                                  const shipmentId = item?.shipmentId;
                                  const baseUrl = process.env.REACT_APP_API_BASE_URL;
                                  const url = `${baseUrl}/fop/apps/PopcAdmin/Shipment/ShipmentContainerInsert?shipmentId=${shipmentId}`;
                                  await downloadLabel(url, shipmentId);
                                } catch (e) { console.error(e) }
                                finally {
                                  setPackingListDownloading(false)
                                }
                              }}
                              defaultColor="bg-blue-800"
                            />
                          </span>
                        )}
                        {!!palletShipments[item?.shipmentId] && allowBoxContentXLSX && (
                          <span className="text-gray-600 ml-2">
                            <Button
                              buttonText={
                                <div>
                                  <DownloadOutlined className="mr-1" style={{ fontSize: 20 }} />
                                  Box Content XLSX
                                </div>
                              }
                              paddingX="px-2"
                              paddingY="py-1"
                              // This needs to be window.location.href because the endpoint is a transition not a screen
                              onClick={() => {
                                window.location.href = `${process.env.REACT_APP_API_BASE_URL}/fop/apps/PopcAdmin/Shipment/exportBoxContentXLSX?shipmentId=${item?.shipmentId}`;
                              }}
                              defaultColor="bg-blue-800"
                            />
                          </span>
                        )}
                        {/* Freight Packing List spreadsheet */}
                        {packingListShipments[item?.shipmentId]?.show && (
                          <span className="text-gray-600 ml-2">
                            <Tooltip
                              title={
                                packingListShipments[item?.shipmentId]?.enabled
                                  ? ""
                                  : packingListShipments[item?.shipmentId]?.reason
                              }
                            >
                              <span
                                className={
                                  packingListShipments[item?.shipmentId]?.enabled
                                    ? ""
                                    : "cursor-not-allowed inline-block"
                                }
                              >
                                <Button
                                  buttonText={
                                    <div>
                                      <DownloadOutlined className="mr-1" style={{ fontSize: 20 }} />
                                      Packing List (xlsx)
                                    </div>
                                  }
                                  paddingX="px-2"
                                  paddingY="py-1"
                                  isDisabled={!packingListShipments[item?.shipmentId]?.enabled}
                                  style={
                                    packingListShipments[item?.shipmentId]?.enabled
                                      ? undefined
                                      : { pointerEvents: "none" }
                                  }
                                  isLoading={freightPackingListDownloading}
                                  onClick={async () => {
                                    try {
                                      setFreightPackingListDownloading(true)
                                      const url = `${process.env.REACT_APP_API_BASE_URL}/fop/apps/PopcAdmin/Shipment/exportFreightPackingListXLSX?shipmentId=${item?.shipmentId}`;
                                      await downloadLabel(url, item?.shipmentId, `PackingList-${item?.shipmentId}.xlsx`);
                                    } catch (e) { console.error(e) }
                                    finally {
                                      setFreightPackingListDownloading(false)
                                    }
                                  }}
                                  defaultColor="bg-blue-800"
                                />
                              </span>
                            </Tooltip>
                          </span>
                        )}
                        {/* Bill of Lading for beta-packed freight shipments */}
                        {bolShipments[item?.shipmentId]?.show && (
                          <span className="text-gray-600 ml-2">
                            <Tooltip
                              title={
                                bolShipments[item?.shipmentId]?.enabled
                                  ? ""
                                  : bolShipments[item?.shipmentId]?.reason
                              }
                            >
                              <span
                                className={
                                  bolShipments[item?.shipmentId]?.enabled
                                    ? ""
                                    : "cursor-not-allowed inline-block"
                                }
                              >
                                <Button
                                  buttonText={
                                    <div>
                                      <DownloadOutlined className="mr-1" style={{ fontSize: 20 }} />
                                      Bill of Lading
                                    </div>
                                  }
                                  paddingX="px-2"
                                  paddingY="py-1"
                                  isDisabled={!bolShipments[item?.shipmentId]?.enabled}
                                  style={
                                    bolShipments[item?.shipmentId]?.enabled
                                      ? undefined
                                      : { pointerEvents: "none" }
                                  }
                                  isLoading={bolDownloading}
                                  onClick={async () => {
                                    try {
                                      setBolDownloading(true)
                                      const url = `${process.env.REACT_APP_API_BASE_URL}/fop/apps/PopcAdmin/Shipment/ShipmentBillOfLading?shipmentId=${item?.shipmentId}`;
                                      await downloadLabel(url, item?.shipmentId, `bill-of-lading-${item?.shipmentId}.pdf`);
                                    } catch (e) { console.error(e) }
                                    finally {
                                      setBolDownloading(false)
                                    }
                                  }}
                                  defaultColor="bg-blue-800"
                                />
                              </span>
                            </Tooltip>
                          </span>
                        )}

                        <div>
                          <span className="font-bold text-lg">
                            ShipmentId: {item?.shipmentId}
                          </span>
                          <span className="text-gray-500 block ltmob:inline ml-2">
                            {getShippedDate(index)}
                          </span>
                        </div>
                      </div>
                      <div className="flex flex-col justify-between sm:flex-row pl-2 xsmall:pl-3">
                        <div className="mr-0 sm:mr-32 md:mr-0 mb-6 sm:mb-0 flex flex-row">
                          <div className="flex flex-col">
                            <h1 className="flex items-center font-bold text-sm mb-2.5">
                              {/* <span className="mr-2">
                                {shipmentDetails &&
                                shipmentDetails.orderPart &&
                                shipmentDetails.orderPart.carrierPartyId
                                  ? shipmentDetails &&
                                    shipmentDetails.orderPart &&
                                    shipmentDetails.orderPart.carrierPartyId
                                  : ""}
                              </span> */}
                              <span className="mr-2">
                                {orderDetailData &&
                                  orderDetailData?.order &&
                                  orderDetailData?.order?.shipmentRouteSegment &&
                                  orderDetailData?.order?.shipmentRouteSegment
                                    ?.length > 0 &&
                                  orderDetailData?.order
                                    ?.shipmentRouteSegment?.[0]?.carrierPartyId
                                  ? orderDetailData?.order
                                    ?.shipmentRouteSegment?.[0]
                                    ?.carrierPartyId
                                  : ""}
                              </span>
                              <span>
                                {orderDetailData &&
                                  orderDetailData?.order &&
                                  orderDetailData?.order?.shipmentRouteSegment &&
                                  orderDetailData?.order?.shipmentRouteSegment
                                    ?.length > 0 &&
                                  orderDetailData?.order
                                    ?.shipmentRouteSegment?.[0]
                                    ?.shippingShipmentMethod
                                  ? orderDetailData?.order
                                    ?.shipmentRouteSegment?.[0]
                                    ?.shippingShipmentMethod
                                  : ""}
                              </span>
                              {orderDetailData &&
                                orderDetailData?.order &&
                                orderDetailData?.order?.shipmentRouteSegment &&
                                orderDetailData?.order?.shipmentRouteSegment
                                  ?.length > 0 &&
                                orderDetailData?.order?.parts?.some(
                                  (data: any) =>
                                    data?.partShipmentItemSourceList?.some(
                                      (item: any) =>
                                        [
                                          "ShipInput",
                                          "ShipPicked",
                                          "ShipScheduled",
                                        ]?.includes(item?.shipmentStatusId)
                                    )
                                ) && (
                                  <BiEdit
                                    className="ml-1 cursor-pointer"
                                    onClick={() => {
                                      setIsShippingMethodModalOpen(true);
                                      shippingMethodForm?.setFieldValue(
                                        "shipmentId",
                                        item?.shipmentId
                                      );
                                    }}
                                  />
                                )}
                              {/* <span>
                                {shipmentDetails &&
                                shipmentDetails.shipmentMethodEnum &&
                                shipmentDetails.shipmentMethodEnum.description
                                  ? shipmentDetails &&
                                    shipmentDetails.shipmentMethodEnum &&
                                    shipmentDetails.shipmentMethodEnum
                                      .description
                                  : ""}
                              </span> */}
                            </h1>

                            <div className="w-48 ">
                              {item.packages &&
                                item.packages[0] &&
                                item.packages[0].routeSegments[0] &&
                                item.packages[0].routeSegments[0] &&
                                item.packages[0].routeSegments[0].trackingUrl ? (
                                <a
                                  className="underline text-primary font-semibold mr-9 md:mr-4 lg:mr-9 hover:text-text-email"
                                  target="_blank"
                                  rel="noreferrer"
                                  href={`${item.packages &&
                                    item.packages[0] &&
                                    item.packages[0].routeSegments[0] &&
                                    item.packages[0].routeSegments[0] &&
                                    item.packages[0].routeSegments[0]
                                      .trackingUrl
                                    }`}
                                >
                                  {item.packages &&
                                    item.packages[0] &&
                                    item.packages[0].routeSegments[0] &&
                                    item.packages[0].routeSegments[0] &&
                                    item.packages[0].routeSegments[0]
                                      .trackingCode}
                                </a>
                              ) : (
                                <h1 className="underline text-primary font-semibold mr-9 md:mr-4 lg:mr-9 hover:text-primary hover:underline">
                                  {item.packages &&
                                    item.packages[0] &&
                                    item.packages[0].routeSegments[0] &&
                                    item.packages[0].routeSegments[0] &&
                                    item.packages[0].routeSegments[0]
                                      .trackingCode}
                                </h1>
                              )}
                            </div>
                          </div>

                          {item.packages &&
                            item.packages[0] &&
                            item.packages[0].routeSegments[0] &&
                            item.packages[0].routeSegments[0] &&
                            item.packages[0].routeSegments[0].labelUrl ? (
                            <div className="mt-7">
                              <a
                                target="_blank"
                                rel="noreferrer"
                                className="font-bold md:block md:mt-2 lg:mt-0 lg:inline bg-gray-200 text-xs py-0.5 px-2.5 rounded-sm hover:text-text-email"
                                href={`${item.packages &&
                                  item.packages[0] &&
                                  item.packages[0].routeSegments[0] &&
                                  item.packages[0].routeSegments[0] &&
                                  item.packages[0].routeSegments[0].labelUrl
                                  }`}
                              >
                                LABEL MADE
                              </a>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="">
                          <h1 className="font-bold text-sm mb-2.5">Sent To</h1>
                          <div>
                            <h1 className="font-medium">
                              {shipmentDetails &&
                                shipmentDetails.postalAddress &&
                                shipmentDetails.postalAddress.toName}
                            </h1>
                            <h1 className="font-medium">
                              {shipmentDetails &&
                                shipmentDetails.postalAddress &&
                                shipmentDetails.postalAddress.address1}
                            </h1>
                            <div className="flex flex-row">
                              <h1 className="font-medium">
                                {shipmentDetails &&
                                  shipmentDetails.postalAddress &&
                                  shipmentDetails.postalAddress.city &&
                                  `${shipmentDetails.postalAddress.city} , `}
                              </h1>
                              <h1 className="font-medium ">
                                {shipmentDetails &&
                                  shipmentDetails.postalAddressStateGeo &&
                                  shipmentDetails.postalAddressStateGeo
                                    .geoCodeAlpha2}
                              </h1>
                              <h1 className="font-medium ml-1.5">
                                {shipmentDetails &&
                                  shipmentDetails.postalAddress &&
                                  shipmentDetails.postalAddress.postalCode}
                                { }
                              </h1>
                              <h1 className="font-medium ml-1.5">
                                {shipmentDetails &&
                                  shipmentDetails.postalAddress &&
                                  shipmentDetails.postalAddress.countryGeoId}
                                {"  "}
                              </h1>
                            </div>
                            {customerContact &&
                              customerContact.telecomNumber &&
                              customerContact.telecomNumber.areaCode ? (
                              <h1 className="font-medium mt-4">
                                {" "}
                                {customerContact.telecomNumber ? "+" : ""}
                                {customerContact &&
                                  customerContact.telecomNumber &&
                                  customerContact.telecomNumber
                                    .countryCode}{" "}
                                ({" "}
                                {customerContact &&
                                  customerContact.telecomNumber &&
                                  customerContact.telecomNumber.areaCode}
                                ){" "}
                                {customerContact &&
                                  customerContact.telecomNumber &&
                                  customerContact.telecomNumber.contactNumber}
                              </h1>
                            ) : (
                              ""
                            )}

                            <a
                              href={`mailto:${emailAddress}`}
                              className="underline font-semibold text-primary hover:text-text-email break-all"
                            >
                              {emailAddress}
                            </a>
                          </div>
                        </div>
                      </div>
                      <h1 className="font-bold pb-3 text-sm mb-4 border-b border-gray-300 ">
                        Items
                      </h1>
                      {shipmentItemDetail &&
                        shipmentItemDetail.map((listItem: any, index: any) => {
                          if (listItem.shipmentId === item.shipmentId) {
                            return (
                              <div className="mt-5">
                                <div className="border-b border-gray-300">
                                  <OrderDetailItem
                                    item={listItem}
                                    imageSrc={
                                      listItem.images[0]
                                        ? `${amazonAws}${listItem.images[0]}`
                                        : listItem.images[0]
                                    }
                                    sku={listItem.sku}
                                    name={listItem.productName}
                                    price={listItem.unitAmount}
                                    qty={listItem.quantity}
                                    variant=""
                                  />
                                  {/* <h1 className='font-bold pb-3 border-b border-gray-300 text-sm mb-4'></h1> */}
                                </div>
                              </div>
                            );
                          }
                          return null;
                        })}
                    </div>
                  );
                })}
            </div>
          ) : (
            <div></div>
          )}
          {orderDetailData?.order?.returnInfo?.length > 0 && (
            <div ref={collapseRef}>
              <Collapse
                // defaultActiveKey={["1"]}
                className="bg-white p-2 rounded-lg shadow-sm mt-5 mb-5"
                collapsible="header"
                ghost
              >
                <Panel
                  id="returnQuantity"
                  header={
                    <h1 className="font-bold text-base">Return Details</h1>
                  }
                  key="2"
                >
                  <Table
                    rowKey="returnQuantity"
                    dataSource={orderDetailData?.order?.returnInfo}
                    columns={ReturnInfo}
                    isPaginated={false}
                  />
                </Panel>
              </Collapse>
            </div>
          )}
        </Loader>
      </div>
    </>
  );
};

export default OrderDetail;
